"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var model_1 = require("../../model");
var service_1 = require("../../../library/base/service");
var Login = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '用户登录';
        _this.code = '101078';
        _this.desc = '';
        _this.requestParams = new model_1.LoginRequest();
        // public responseParams: LoginResponse;
        _this.method = fetch_1.Methods.POST;
        _this.isSecurity = false;
        return _this;
    }
    return Login;
}(service_1.BaseService));
exports.Login = Login;
//# sourceMappingURL=login.js.map